import { maybe } from '@passionware/monads';
import { SimpleStore } from '@passionware/simple-store';
import { stringifyQueryParams } from 'v5/core/list-query/queryString';
import { NavigateFunction, NavigationService } from './NavigationService';

export interface NavigationServiceConfig {
  navigateFunctionStore: SimpleStore<{ navigate: NavigateFunction }>;
}
export function createNavigationService(
  config: NavigationServiceConfig
): NavigationService {
  const api: NavigationService = {
    navigate: (...args) => {
      const navigationFunction =
        config.navigateFunctionStore.getCurrentValue().navigate;
      if (maybe.isAbsent(navigationFunction)) {
        throw new Error('Navigation function not injected');
      }

      navigationFunction(...args);
    },
    navigateWithQueryParams: (path, params, options) => {
      api.navigate(
        {
          pathname: path,
          search: stringifyQueryParams(params)
        },
        options
      );
    },
    openInNewTab: (path, params) => {
      const url = path + '?' + stringifyQueryParams(params);
      window.open(url, '_blank');
    }
  };
  return api;
}
